module.exports = __webpack_public_path__ + "img/mm.d50708bd.svg";